module.exports = __webpack_public_path__ + "static/media/8OLA4.10ce8bd0.jpg";